import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DinnerDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dinner_dining"}/>
}
